module.exports = __webpack_public_path__ + "static/media/index.954ddd6e.mp3";